"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyData = exports.PropertyValue = exports.PropertyObjectValue = exports.LinkValue = exports.VectorObjectValue3 = exports.VectorObjectValue2 = exports.PropertyTypes = void 0;
exports.isPropertyWithLinkValueType = isPropertyWithLinkValueType;
exports.isPropertyWithLinkValueTypeButStringValue = isPropertyWithLinkValueTypeButStringValue;
exports.isPropertyWithVector2ValueType = isPropertyWithVector2ValueType;
exports.isPropertyWithVector3ValueType = isPropertyWithVector3ValueType;
const tslib_1 = require("tslib");
// TODO This can easily go out of sync since the Types and Values have to be both added. Find a way to stringify
//   the type or use a function to create the type out of the values.
const constants_1 = require("@buildwithflux/constants");
const zod_1 = tslib_1.__importDefault(require("zod"));
const vector_1 = require("./vector");
var constants_2 = require("@buildwithflux/constants");
Object.defineProperty(exports, "PropertyTypes", { enumerable: true, get: function () { return constants_2.PropertyTypes; } });
/**
 * Vector object value for 2D positions (schematic positions)
 */
exports.VectorObjectValue2 = zod_1.default.object({
    type: zod_1.default.literal("vector2"),
    data: vector_1.StoredSchematicPosition2,
});
/**
 * Vector object value for 3D positions
 */
exports.VectorObjectValue3 = zod_1.default.object({
    type: zod_1.default.literal("vector3"),
    data: vector_1.StoredAutoVector3,
});
/**
 * Hold for any link value for prop such as datasheet url,
 * it follows how a markdown link is formed: a text and a href
 */
exports.LinkValue = zod_1.default.object({
    type: zod_1.default.literal("link"),
    /**
     * This is the original url from distributor
     */
    text: zod_1.default.string(),
    /**
     * This is the cached version, a url pointing to our gcs
     */
    url: zod_1.default.string(),
});
/**
 * Discriminated union for object-based property values
 */
exports.PropertyObjectValue = zod_1.default.discriminatedUnion("type", [exports.VectorObjectValue2, exports.VectorObjectValue3, exports.LinkValue]);
/**
 * Property values can be basic primitives or structured objects with type discrimination
 */
exports.PropertyValue = zod_1.default.union([zod_1.default.string(), zod_1.default.number(), zod_1.default.boolean(), exports.PropertyObjectValue]);
exports.PropertyData = zod_1.default.object({
    /**
     * Name of the property e.g. Resistance.  Provided by the user.  Completely arbitrary - a user can choose any name
     * they want for a property.
     * @remarks If a property name is prefixed by a double underscore e.g. __myName, it will be hidden from the property
     * editor.
     */
    name: zod_1.default.string(),
});
/*
 * Check if a property's value is of @see {LinkValue} type
 */
function isPropertyWithLinkValueType(property) {
    return (!!property &&
        constants_1.propertyDefinitionsByLabel[property.name]?.valueType === "link" &&
        exports.LinkValue.safeParse(property.value).success);
}
/**
 * Check if a property's value is of @see {LinkValue} type, but the
 * value is still a string, this can happen when the property is not
 * updated to fit the new schema yet
 */
function isPropertyWithLinkValueTypeButStringValue(property) {
    return (!!property &&
        constants_1.propertyDefinitionsByLabel[property.name]?.valueType === "link" &&
        typeof property.value === "string");
}
/**
 * Check if a property's value is of @see {VectorObjectValue2} type
 */
function isPropertyWithVector2ValueType(property) {
    return !!property && exports.VectorObjectValue2.safeParse(property.value).success;
}
/**
 * Check if a property's value is of @see {VectorObjectValue3} type
 */
function isPropertyWithVector3ValueType(property) {
    return !!property && exports.VectorObjectValue3.safeParse(property.value).success;
}
//# sourceMappingURL=property.js.map